<template>
  <div class="true-false-container" :class="device.isMobile ? 'true-false-container-mobile' : ''"  :id="content.key">
    <div class="reset" @click.stop="reset"></div>
    <div class="item" v-for="(item, index) in content.content" :key="item.key">
      <div class="input-box">
        <span
          class="input-text"
          :ref="item.key"
          contenteditable
          @input="input(item.key)"
          @click.stop="(e)=> {
            findChapterFrom(e)
            e.stopPropagation();
          }"
        ></span>
        {{ index + 1 }}
      </div>
      <div class="question-content">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
/*
判断题组件
*/
export default {
  name: "trueOrFalse",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    // 输入时做限制 只能输入一位
    input(key) {
      let obj = this.$refs[key][0];
      let textValue = obj.innerText;
      
      if(textValue.length > 1) {
        obj.innerHTML = textValue.substring(0, 1)
      }
      this.setFocus(key, 1)
    },
    // 聚焦后把光标放到最后
    setFocus(key, index) {
      let obj = this.$refs[key][0];

      if (document.createRange) {
        // 获取选定对象
        let selection = getSelection();
        let range = document.createRange();

        range.setStart(obj.firstChild || obj, index);
        range.setEnd(obj.firstChild || obj, index);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    reset() {
      this.content.content.forEach(item => {
        let obj = this.$refs[item.key][0];
        obj.innerHTML = ''
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.true-false-container{
  position: relative;
  
  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -60rem;
    right: 10rem;
    cursor: pointer;
    z-index: 5;
  }

  .item{
    display: flex;
    align-items: flex-start;
    font-size: 28rem;
    line-height: 36rem;
    color: #333;
    font-family: Calibri;
    margin-bottom: 22rem;
  }

  .input-box{
    flex: 0 0 80rem;
    margin-right: 22rem;
    color: #5CA683;
    font-style: italic;
    display: flex;
    
    .input-text{
      flex: 1;
      border-bottom: 1rem solid #5CA683;
      text-align: center;
      outline: none;
    }
  }
  .question-content{
    flex: 1;
  }
}
.true-false-container-mobile{
  
  .reset{
    width: 44rem;
    height: 44rem;
    top: -70rem;
  }
}
</style>